/* eslint-disable @typescript-eslint/naming-convention */
import { SegmentSchema } from '@sondermind/segment';

export enum ProviderInvitedClientsEvents {
  PROVIDER_INVITED_CLIENTS = 'Provider Invited Clients',
}

export interface IProviderInvitedClientsEventData {
  persona_provider_id: number;
  invite_type: 'single' | 'bulk';
  client_count: number;
  referral_ids: number[];
  referral_member_ids: number[];
  // Optional: sent for single invites, omitted for bulk (each row may have a different value)
  intake_required?: boolean;
  success: boolean;
  failure_count: number;
}

export interface IProviderInvitedClientsSchema extends SegmentSchema {
  [ProviderInvitedClientsEvents.PROVIDER_INVITED_CLIENTS]: IProviderInvitedClientsEventData;
}
